import { render, staticRenderFns } from "./timestamps-column.vue?vue&type=template&id=645c6ab4"
import script from "./timestamps-column.vue?vue&type=script&lang=js"
export * from "./timestamps-column.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports